import * as React from 'react';
import styles from './index.less';
import fMessage from '@/components/fMessage';
import { UpdateBaseInfoAction } from '@/models/exhibitInfoPage';
import FCoverImage from '@/components/FCoverImage';
import FIcons from '@/components/FIcons';
import { FI18n } from '@freelog/tools-lib';
import FUploadCover from '@/components/FUploadCover';

interface FCoverImageEditorProps {
  src: string;
  width: number;
  use?: 'resource' | 'exhibit';

  onChange?(url: string): void;
}

function FCoverImageEditor({ src, use = 'exhibit', width, onChange }: FCoverImageEditorProps) {
  return (<FUploadCover
    style={{ height: 195 }}
    use={use}
    onError={(err) => {
      fMessage(err, 'error');
    }}
    onUploadSuccess={(url: string) => {
      // console.log(url, 'url@#$!@#$@#@#$@#');
      // dispatch<UpdateBaseInfoAction>({
      //   type: 'exhibitInfoPage/updateBaseInfo',
      //   payload: {
      //     exhibit_Cover: url,
      //   },
      // });
      onChange?.(url);
    }}>
    <div className={styles.cover}>
      <FCoverImage
        src={src}
        width={width}
        style={{ borderRadius: 6 }}
      />
      <div className={styles.coverEdit}>
        <FIcons.FEdit style={{ fontSize: 32 }} />
        <div style={{ height: 10 }} />
        <div>{FI18n.i18nNext.t('btn_edit_cover')}</div>
      </div>
    </div>
  </FUploadCover>);
}

export default FCoverImageEditor;
